import { IdentityCheckStatus } from '@afterpay/types'
import { Route } from '../../config/router'
import { setLoggedInLoadingMessageKey, showToast, useAppDispatch, useAppRouter, useIdentityVerifyMutation } from '../../state'
import { Channel } from '@afterpaytouch/portal-api/types'
import { useAmplitudeWithEnduringEventProperties } from '../../integrations/amplitude'
import { TrackingEvent } from '../../model/amplitude'

interface HandleIdentityVerifyOutcomeOptions {
  status: IdentityCheckStatus
  showToastBody: boolean
}
interface VerifyAndHandleOptions {
  showToastBody: boolean
}
export const useIdentityVerifyRedirect = (): {
  verifyAndHandleOutcome: (opts: VerifyAndHandleOptions) => Promise<IdentityCheckStatus>
} => {
  const dispatch = useAppDispatch()
  const router = useAppRouter()
  const [identityVerify] = useIdentityVerifyMutation()
  const { logEvent } = useAmplitudeWithEnduringEventProperties()

  const handleIdentityVerifyOutcome = ({ status, showToastBody }: HandleIdentityVerifyOutcomeOptions): void => {
    switch (status) {
      case IdentityCheckStatus.VERIFIED: {
        logEvent(TrackingEvent.ACCOUNT_VERIFIED)
        dispatch(showToast({ toastType: 'accountVerified', showToastBody }))
        // Consider about AU Reg flow here
        router.replace(Route.LOGGED_IN)
        break
      }
      case IdentityCheckStatus.FAILED: {
        router.push(`${Route.TERMINAL_ERROR}/identityVerificationFailedManual`)
        break
      }
      default: {
        dispatch(setLoggedInLoadingMessageKey('verifyIdentity'))
        router.replace(Route.LOGGED_IN)
        break
      }
    }
  }

  const verifyAndHandleOutcome = async ({ showToastBody }: VerifyAndHandleOptions): Promise<IdentityCheckStatus> => {
    const { identityCheckStatus } = await identityVerify({ channel: Channel.PORTAL }).unwrap()
    handleIdentityVerifyOutcome({ status: identityCheckStatus, showToastBody })
    return identityCheckStatus
  }

  return { verifyAndHandleOutcome }
}
